// src/components/Separation/DashboardStats.tsx

import React from 'react';
import { DashboardStats } from '../../types/separation';

interface DashboardStatsProps {
  stats: DashboardStats | null;
  loading: boolean;
  error: string | null;
  onRefresh: () => void;
}

const DashboardStatsComponent: React.FC<DashboardStatsProps> = ({ stats, loading, error, onRefresh }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-500">Loading dashboard data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <p className="text-red-600">{error}</p>
        <button onClick={onRefresh} className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">
          Retry
        </button>
      </div>
    );
  }

  if (!stats) return null;

  const statCards = [
    { title: 'Total Resignations', value: stats.resignations.total, color: 'blue', icon: '📋' },
    { title: 'Pending Approval', value: stats.resignations.pending_approval, color: 'yellow', icon: '⏳' },
    { title: 'Completed Resignations', value: stats.resignations.completed, color: 'green', icon: '✅' },
    { title: 'Total Terminations', value: stats.terminations.total, color: 'red', icon: '⚠️' },
    { title: 'Pending Checklists', value: stats.exit_checklists.pending, color: 'orange', icon: '📝' },
    { title: 'Pending Settlements', value: stats.settlements.pending, color: 'purple', icon: '💰' },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {statCards.map((card) => (
        <div key={card.title} className="bg-white rounded-xl px-5 py-4 shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="flex items-center gap-3">
            <div className={`w-12 h-12 bg-${card.color}-100 rounded-xl flex items-center justify-center`}>
              <span className="text-2xl">{card.icon}</span>
            </div>
            <div>
              <p className="text-sm text-gray-500">{card.title}</p>
              <p className={`text-2xl font-bold text-${card.color}-600`}>{card.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStatsComponent;